module.exports = __webpack_public_path__ + "img/google-play.ac71ef8e.svg";